import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Save, Loader2 } from "lucide-react";

export default function AddTestimonialPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(!!id);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    clientFullName: "",
    clientPosition: "",
    clientComment: "",
  });

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const res = await api.get(`/testimonial/${id}`);
        const d = res.data;
        setFormData({
          clientFullName: d.clientFullName || "",
          clientPosition: d.clientPosition || "",
          clientComment: d.clientComment || "",
        });
      } catch {
        toast.error("Yorum yüklenemedi");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.clientFullName.trim()) return toast.error("Ad soyad gerekli");
    if (!formData.clientComment.trim()) return toast.error("Yorum gerekli");
    setSaving(true);

    try {
      if (id) {
        await api.put(`/testimonial/${id}`, formData);
        toast.success("Yorum güncellendi");
      } else {
        await api.post("/testimonial", formData);
        toast.success("Yorum eklendi");
      }
      navigate("/testimonial-list");
    } catch {
      toast.error(id ? "Yorum güncellenemedi" : "Yorum eklenemedi");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>{id ? "Yorum Düzenle" : "Yorum Ekle"}</h2>
          <p className="page-subtitle">
            {id ? "Mevcut yorumu düzenleyin" : "Yeni müşteri yorumu ekleyin"}
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="content-card" style={{ maxWidth: 600 }}>
          <div className="form-field">
            <label>Ad Soyad</label>
            <input
              type="text"
              name="clientFullName"
              value={formData.clientFullName}
              onChange={handleChange}
              className="form-input"
              placeholder="Müşteri adı soyadı"
            />
          </div>

          <div className="form-field">
            <label>Pozisyon / Firma</label>
            <input
              type="text"
              name="clientPosition"
              value={formData.clientPosition}
              onChange={handleChange}
              className="form-input"
              placeholder="Örn: CEO, ABC Şirketi"
            />
          </div>

          <div className="form-field">
            <label>Yorum</label>
            <textarea
              name="clientComment"
              value={formData.clientComment}
              onChange={handleChange}
              className="form-input"
              rows={5}
              placeholder="Müşteri yorumu"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={saving}
          >
            {saving ? (
              <>
                <Loader2 size={18} className="spin" /> Kaydediliyor...
              </>
            ) : (
              <>
                <Save size={18} /> {id ? "Güncelle" : "Kaydet"}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
